"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatLargeNumber = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = tslib_1.__importStar(require("react"));
var react_chartjs_2_1 = require("react-chartjs-2");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var DailyUsageGraph_hooks_1 = require("../../DailyUsageGraph/DailyUsageGraph.hooks");
/** note: does not round number */
var toFixedIfNecessary = function (num, decimalPoints) {
    var _a = "".concat(num).split('.'), wholeNum = _a[0], decimals = _a[1];
    return (decimals !== null && decimals !== void 0 ? decimals : '').length <= decimalPoints ? num : Number("".concat(wholeNum, ".").concat(decimals.slice(0, decimalPoints)));
};
/** Format a given number.
 * - Below 10'000 number will remain the same (999 => 999)
 * - At 10'000 or above 'K' will be added (10'000 -> 10K)
 * - At 1 million or above 'M' will be added (1'000'000' => 1M)
 * Note that this func does not round to the given decimalPoints -> given decimalPoints of 2, 99.999 will be 99.99 and will not be 100
 */
var formatLargeNumber = function (num, decimalPoints) {
    if (decimalPoints === void 0) { decimalPoints = 2; }
    var format = function (n, unit) { return "".concat(toFixedIfNecessary(n, decimalPoints)).concat(unit); };
    var len = num.toString().split('.')[0].length;
    var lessThanThousand = len < 4;
    if (lessThanThousand) {
        return format(num, '');
    }
    var lessThanMillion = len < 7;
    if (lessThanMillion) {
        return format(num / 1000, 'K');
    }
    return format(num / 1000000, 'M');
};
exports.formatLargeNumber = formatLargeNumber;
var YAxisContainerDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  min-height: 0;\n  max-width: ", ";\n"], ["\n  ", "\n  min-height: 0;\n  max-width: ", ";\n"])), function (_a) {
    var percentage = _a.percentage, verticalPadding = _a.verticalPadding;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      flex-basis: calc(", "% + ", "px);\n    "], ["\n      flex-basis: calc(", "% + ", "px);\n    "])), percentage, verticalPadding);
}, function (_a) {
    var width = _a.width;
    return width;
});
function YAxis(_a) {
    var periodData = _a.periodData, padding = _a.padding, reverseAxis = _a.reverseAxis, _b = _a.small, small = _b === void 0 ? true : _b, _c = _a.maxY, maxY = _c === void 0 ? 1 : _c, isElectric = _a.isElectric, hasSolar = _a.hasSolar, equalSize = _a.equalSize;
    var yAxisWidthPx = 40;
    var chartData = (0, react_1.useMemo)(function () {
        var graphData = periodData === null || periodData === void 0 ? void 0 : periodData.map(function (x) { return (x >= 0 ? x : 0); });
        return {
            labels: [],
            datasets: [
                {
                    data: graphData,
                    backgroundColor: 'green',
                },
            ],
        };
    }, [periodData]);
    var chartOptions = {
        animation: {
            duration: 0,
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: padding,
        },
        scales: {
            x: {
                display: !reverseAxis,
                grid: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    display: false,
                    font: {
                        size: 15,
                    },
                    padding: 2,
                },
            },
            y: tslib_1.__assign(tslib_1.__assign({ reverse: reverseAxis !== null && reverseAxis !== void 0 ? reverseAxis : false }, (maxY && { max: maxY })), { ticks: {
                    callback: function (value) {
                        return "$".concat((0, exports.formatLargeNumber)(Math.abs(value))).padEnd(value && !isElectric ? 4 : 0, ' ');
                    },
                    maxTicksLimit: small ? 2 : 3,
                    minRotation: 90,
                    font: {
                        size: 13,
                        family: "'stevie-sans', 'AvenirLTPro-Roman', 'Arial', 'Tahoma', sans-serif",
                    },
                    color: "".concat(asg_1.colors.tertiaryText.light, "D9"),
                    padding: 0,
                }, grid: {
                    display: false,
                    drawBorder: false,
                }, afterBuildTicks: function (axis) {
                    axis.ticks = small ? [{ value: 0 }, { value: maxY }] : [{ value: 0 }, { value: maxY / 2 }, { value: maxY }];
                }, afterFit: function (axis) {
                    axis.width = yAxisWidthPx;
                } }),
        },
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    var nonSolarHeight = (0, DailyUsageGraph_hooks_1.useGraphNonSolarHeight)({
        isSmall: small,
        isSnapshot: false,
        isEqualSized: equalSize,
        hasSolar: hasSolar,
        paddingOffset: 30,
    });
    var solarHeight = (0, DailyUsageGraph_hooks_1.useGraphSolarHeight)({
        isSmall: small,
        isSnapshot: false,
        isEqualSized: equalSize,
        paddingOffset: 30,
    });
    var graphHeight = isElectric ? nonSolarHeight : solarHeight;
    return (react_1.default.createElement(YAxisContainerDiv, { width: "".concat(yAxisWidthPx, "px"), "data-testid": "yAxisGraph", percentage: graphHeight.percentage, verticalPadding: graphHeight.verticalPaddingPx },
        react_1.default.createElement(react_chartjs_2_1.Bar, { data: chartData, options: chartOptions })));
}
exports.default = YAxis;
var templateObject_1, templateObject_2;
//# sourceMappingURL=YAxis.js.map